export enum ArticleType {
  RENTAL = "RentalAccommodationArticle",
  SEASONAL = "SeasonalAccommodationArticle",
  ANNUAL = "AnnualAccommodationArticle",
  SALE = "SaleAccommodationArticle"
}

export type ArticleUrlData = {
  __typename: ArticleType;
  id: string;
  slug: string;
}

export const buildSearchUrl = (type: ArticleType): string => {
  switch (type) {
    case ArticleType.RENTAL:
      return "/location/courte-duree/";
    case ArticleType.SEASONAL:
      return "/location/saison/";
    case ArticleType.ANNUAL:
      return "/location/annuel/";
    case ArticleType.SALE:
      return "/vente/";
  }
}

export const buildArticleUrl = (data: ArticleUrlData) =>
  `${buildSearchUrl(data.__typename)}${data.slug}?refId=${data.id}`;

export function buildPageUrl(str: string): string {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}
